import { API } from 'src/api';
export const useSidebarService = () => {
  async function fetchSidebarDetails(mode?: string) {
    try {
      const response = await API.get(`/files/sidebar?mode=${mode}`);
      if (response.data.success) {
        return fetchSidebarFormat(response.data.data);
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  async function pinFile({ fileId, pin }: { fileId: string; pin: boolean }) {
    try {
      const response = await API.put(`/files/pin`, {
        id: fileId,
        pin: pin,
      });
      return response.data;
    } catch (error) {
      console.error('errror', error);
      return null;
    }
  }

  async function setSidebarWorkspace(workspaceId: string) {
    try {
      const response = await API.put(`/files/sidebar`, {
        workspace: workspaceId,
      });
      return response.data;
    } catch (error) {
      console.error('errror', error);
      return null;
    }
  }

  return {
    fetchSidebarDetails,
    pinFile,
    setSidebarWorkspace,
  };
};

function fetchSidebarFormat(data) {
  return {
    lessonPinnedFiles: data.lessons.map((lessonData) => {
      return {
        slug: lessonData.slug,
        tag: lessonData.tag,
        name: lessonData.title,
      };
    }),
    sharedPinnedFiles: data.shared?.files.map((fileData) => {
      return {
        fileId: fileData?._id,
        primaryFile: {
          id: fileData?.file?._id,
          type: fileData.filetype === 'creation' ? 'document' : fileData.filetype,
          view: fileData.view,
        },
        name: fileData?.file?.name || fileData?.file?.title || fileData?.title || 'Untitled',
        icon: fileData?.file?.icon,
      };
    }),
    privatePinnedFiles: data?.private.files.map((fileData) => {
      return {
        fileId: fileData?._id,
        primaryFile: {
          id: fileData?.file?._id,
          type: fileData.filetype === 'creation' ? 'document' : fileData.filetype,
          view: fileData.view,
        },
        name: fileData?.file?.name || fileData?.file?.title || fileData?.title || 'Untitled',
        icon: fileData?.file.icon,
      };
    }),
    workspaces: data?.workspaces.map((fileData) => {
      return {
        _id: fileData._id,
        open: false,
        collapseBoards: fileData.collapseBoards,
        access: fileData.access,
        collapseDocuments: fileData.collapseDocuments,
        coverOffset: fileData.coverOffset,
        isCustom: fileData.isCustom,
        icon: fileData.icon,
        isPublic: fileData.isPublic,
        members: fileData.members,
        name: fileData.name || fileData.title,
        owner: fileData.owner,
        workspaceId: fileData.workspaceId,
        lms: fileData.lms,
        files: fileData.pinned?.files
          ? fileData.pinned.files.map((pinnedFile) => {
              return {
                fileId: pinnedFile._id,
                primaryFile: {
                  id: pinnedFile?.file,
                  type: pinnedFile.filetype === 'creation' ? 'document' : pinnedFile.filetype,
                  view: pinnedFile.file,
                },
                name:
                  pinnedFile?.file?.name ||
                  pinnedFile?.file?.title ||
                  pinnedFile?.title ||
                  'Untitled',
                icon: pinnedFile.icon,
              };
            })
          : [],
      };
    }),
    isLessonsOpen: data?.settings?.lesson_open,
    isPrivateOpen: data?.settings?.private_open,
    isWorkspaceOpen: data?.settings?.workspace_open,
    isCRMOpen: data?.settings?.crm_open,
    isSharedOpen: data?.settings?.shared_open,
    workspace: data?.workspace,
  };
}
